module.exports = __webpack_public_path__ + "static/img/dmn-logo.5c82b486.png";